import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Suppress benign ResizeObserver errors
const resizeObserverLoopErr = /ResizeObserver loop completed with undelivered notifications/;
const resizeObserverLoopLimitErr = /ResizeObserver loop limit exceeded/;

const originalError = console.error;
console.error = (...args) => {
  if (
    args[0] &&
    (resizeObserverLoopErr.test(args[0]) || resizeObserverLoopLimitErr.test(args[0]))
  ) {
    return;
  }
  originalError.call(console, ...args);
};

window.addEventListener('error', (event) => {
  if (
    resizeObserverLoopErr.test(event.message) ||
    resizeObserverLoopLimitErr.test(event.message)
  ) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID"}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
